// export this package's api
import Align from './Align';
export default Align;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-align@3.0.0-rc.1@rc-align/es/index.js
// module id = 493
// module chunks = 0